<template>
  <div class="form-incident-coup-attempt-detail">
    <!-- coup_attempt_type -->
    <b-form-group :label="'A) ' + $t('coup_attempt_type')">
      <div v-if="getCoupAttemptTypeNames.length || _.get(entity, 'other_coup_attempt')">
        <span v-for="(typeName, index) in getCoupAttemptTypeNames" :key="index">
          {{ typeName }}<span v-if="index < getCoupAttemptTypeNames.length - 1 || _.get(entity, 'other_coup_attempt')">, <br></span>
        </span>
        <span v-if="_.get(entity, 'other_coup_attempt')">
          Outro: {{ _.get(entity, 'other_coup_attempt') }}
        </span>
      </div>
      <div v-else>-</div>
    </b-form-group>

    <!-- incident_form_date_coup_attempt -->
    <b-form-group :label="'B) ' + $t('incident_form_date_coup_attempt')">
      <div>{{ _.get(entity, 'incident_date_fmt') || '-' }}</div>
    </b-form-group>

    <!-- incident_form_unit -->
    <b-form-group :label="'C) ' + $t('incident_form_unit')">
      <div>{{ _.get(entity, 'legal_entity.name') || '-' }}</div>
    </b-form-group>

    <!-- incident_form_description_coup_attempt -->
    <b-form-group :label="'D) ' + $t('incident_form_description_coup_attempt')">
      <div class="text-break">{{ _.get(entity, 'description') || '-' }}</div>
    </b-form-group>

    <!-- incident_form_who_reported_coup_attempt -->
    <b-form-group :label="'E) ' + $t('incident_form_who_reported_coup_attempt')+$t('incident_form_name_tel_email')">
      <div class="text-break">{{ _.get(entity, 'who_reported') || '-' }}</div>
    </b-form-group>

    <!-- incident_form_responsible_unit -->
    <b-form-group :label="'F) ' + $t('incident_form_responsible_unit')+$t('incident_form_name_tel_email')">
      <div class="text-break">{{ _.get(entity, 'responsible_unit') || '-' }}</div>
    </b-form-group>

    <!-- incident_form_how_identified -->
    <b-form-group :label="'G) ' +  $t('incident_form_how_identified')">
      <div class="text-break">{{ _.get(entity, 'how_identified') || '-' }}</div>
    </b-form-group>

     <!-- incident_form_general_attachments -->
     <b-form-group :label="$t('incident_form_attachments')" v-if="getGeneralAttachments.length">
      <b-list-group>
        <b-list-group-item
          v-for="(file, idx) in getGeneralAttachments"
          :key="idx"
          class="d-flex justify-content-between align-items-center"
        >
          <div>
            <i class="feather icon-file-text text-primary mr-2"></i>
            <a v-if="getDownloadUrl(file)"
               :href="getDownloadUrl(file)"
               target="_blank"
               class="mr-2 download-link text-primary"
               title="Baixar arquivo">
              <i class="feather icon-download"></i>
            </a>
            <strong>{{ getFileName(file) }}</strong>
            <small class="ml-2 text-muted" v-if="getFileSize(file)">
              ({{ formatFileSize(getFileSize(file)) }})
            </small>
          </div>
        </b-list-group-item>
      </b-list-group>
    </b-form-group>

  </div>
</template>

<script>

import {
  BFormGroup,
  VBTooltip
} from 'bootstrap-vue'

import RequestFormIncidentService from '@/services/api/incident/RequestFormIncidentService'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BFormGroup,
  },
  props: {
    entity: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      coupAttemptTypeList: [],
      services: {
        requestFormIncidentService: null,
      }
    }
  },
  computed: {
    getCoupAttemptTypeNames() {
      const coupAttemptTypes = _.get(this.entity, 'incident_coup_attempt_types', [])
      return coupAttemptTypes.map(type => type.name)
    },
    getGeneralAttachments() {
      const generalAttachments = _.get(this.entity, 'general_attachments', [])
      return generalAttachments
    }
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return null

      // Se já está no formato DD/MM/YYYY, retorna como está
      if (dateString.includes('/')) {
        return dateString
      }

      // Se está no formato YYYY-MM-DD, converte para DD/MM/YYYY
      if (dateString.includes('-')) {
        const [year, month, day] = dateString.split('-')
        return `${day}/${month}/${year}`
      }

      // Tenta usar moment se disponível
      if (this.$moment) {
        return this.$moment(dateString).format('DD/MM/YYYY')
      }

      return dateString
    },

    // Método para obter nome do arquivo
    getFileName(file) {
      if (!file) return '';

      // Se é um arquivo que foi enviado (tem name)
      if (file.name) {
        return file.name;
      }

      // Se é um arquivo que foi carregado do servidor (tem file_name)
      if (file.file_name) {
        return file.file_name;
      }

      // Se é um arquivo que tem metadata com original_name
      if (file.metadata && file.metadata.original_name) {
        return file.metadata.original_name;
      }

      return 'Arquivo anexado';
    },

    // Método para obter tamanho do arquivo
    getFileSize(file) {
      if (!file) return null;

      // Se é um arquivo que foi enviado (tem size)
      if (file.size) {
        return file.size;
      }

      // Se é um arquivo que tem metadata com size
      if (file.metadata && file.metadata.size) {
        return file.metadata.size;
      }

      return null;
    },

    // Método para obter URL de download
    getDownloadUrl(file) {
      if (!file) return null;

      // Se é um arquivo que foi enviado (tem url_tmp)
      if (file.url_tmp) {
        return file.url_tmp;
      }

      // Se é um arquivo que foi carregado do servidor (tem metadata)
      if (file.metadata && file.metadata.url_tmp) {
        return file.metadata.url_tmp;
      }

      // Verificar outras possíveis propriedades de URL
      if (file.url_temp) {
        return file.url_temp;
      }

      if (file.url) {
        return file.url;
      }

      if (file.download_url) {
        return file.download_url;
      }

      return null;
    },

    // Método para formatar tamanho do arquivo
    formatFileSize(size) {
      if (!size) return '';
      if (size < 1024) return size + ' B';
      if (size < 1024 * 1024) return (size / 1024).toFixed(1) + ' KB';
      return (size / (1024 * 1024)).toFixed(1) + ' MB';
    }
  },
  mounted() {
    console.log('FormIncidentCoupAttemptDetail mounted com entity:', this.entity)
  },
  beforeMount() {

  }
}
</script>

<style lang="scss" scoped>
.text-break {
  word-break: break-word;
  white-space: pre-wrap;
}

// Estilizar especificamente este componente de detalhe
.form-incident-coup-attempt-detail {
  ::v-deep .form-group {
    label {
      font-weight: 700 !important;
      color: #495057 !important;
      font-size: 0.9rem !important;
      text-transform: none !important;
      margin-bottom: 0.5rem !important;
    }

    > div {
      font-weight: 400 !important;
      font-size: 0.95rem !important;
      background-color: #f8f9fa !important;
      padding: 0.5rem 0.75rem !important;
      border: 1px solid #e9ecef !important;
      border-radius: 0.25rem !important;
      min-height: 2.25rem !important;
      display: flex !important;
      align-items: center !important;
    }
  }
}
</style>
